export default function TripTravellerAllocationFlightService() {
    Object.assign(this, {
        getTravellersWhichAreAllowedToSelectSeat,
    });

    function getTravellersWhichAreAllowedToSelectSeat(tripDetails) {
        const isValid = tripDetails
            && tripDetails.Travelers
            && tripDetails.Travelers.Adult
            && tripDetails.Travelers.Child;

        if (!isValid) {
            return [];
        }
        return [
            ...tripDetails.Travelers.Adult,
            ...tripDetails.Travelers.Child,
        ];
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-flight-service.js